import { render, staticRenderFns } from "./WidgetsReportPurchaseOrder.vue?vue&type=template&id=60243141&scoped=true"
import script from "./WidgetsReportPurchaseOrder.vue?vue&type=script&lang=js"
export * from "./WidgetsReportPurchaseOrder.vue?vue&type=script&lang=js"
import style0 from "./WidgetsReportPurchaseOrder.vue?vue&type=style&index=0&id=60243141&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60243141",
  null
  
)

export default component.exports